import { settings_system_paymentProvider } from '../core-types';
import { FormattedMessage } from 'react-intl';
import { Flex, Text, Image } from '.';

export function PaymentProviderInfo({
  paymentProvider
}: {
  paymentProvider: settings_system_paymentProvider;
}) {
  switch (paymentProvider.__typename) {
    case 'PaymentProviderPayex': {
      return (
        <Text mt="xs" mute typoStyle="xxs">
          <FormattedMessage
            id="modules.BuyProduct.SummaryStep.safePayment"
            defaultMessage="Safe payment with PayEx."
          />
          <br />
          <FormattedMessage
            id="modules.BuyProduct.SummaryStep.visaMastercard"
            defaultMessage="We accept VISA and MasterCard."
          />
        </Text>
      );
    }
    case 'PaymentProviderStripe': {
      return (
        <Flex justifyContent="center">
          <Image
            src="/static/assets/powered_by_stripe.svg"
            alt="Powered by Stripe"
          />
        </Flex>
      );
    }
    case 'PaymentProviderNevogate': {
      return (
        <Flex justifyContent="center">
          <Image
            src="/static/assets/nevogate-logo.svg"
            alt="Powered by Nevogate"
          />
        </Flex>
      );
    }
  }
}
